import * as Sentry from "@sentry/react";

function getEnvironment() {
  const hostname = window.location.hostname;

  if (hostname === "app.hsechain.com") {
    return "pro";
  }
  if (hostname === "app.dev.eiralabs.red.upc.edu") {
    return "dev";
  }

  return null; // Don't initialize Sentry for other environments
}

export const environment = getEnvironment();

if (environment) {
  Sentry.init({
    dsn: "https://71cc715305189b8214c2f03a82d495f0@o4509916951543808.ingest.de.sentry.io/4509917025009744",
    environment,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],

    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    enabled: !!environment,
  });
}
